const TextFieldsStyles = ()  => (
  {
    styleOverrides: {
      root: {
        backgroundColor: "var(--Schemes-Surface-Container-Highest)", // Задний фон
        borderRadius: "12px", // Скругление
        "& .MuiOutlinedInput-root": {
          padding: "0px",
          "& fieldset": {
            border: "none", // Убираем бордер
          },
        },
        "& .MuiInputBase-input": {
          fontFamily: "Roboto",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "24px",
          letterSpacing: "0.5px",
          color: "var(--Schemes-On-Surface-Variant)",
          padding: "6px",
        },
      }
    }
  }
)
export default TextFieldsStyles

/*

font-family: Roboto;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px;
letter-spacing: 0.5px;
 */